import { GoodBetterBestTile, GoodBetterBestValue } from '../../types/GoodBetterBest'
import PageDataUtil from '../pageDataUtil/pageDataUtil'
import ProductTileCollectionUtil, {
  CalloutDataType,
  ProductTileModel
} from '../productTileCollection/productTileCollection'
import { BFFPageData } from '../../services/serviceClients/BffClient'
import { Logger } from '@vp/ubik-logging'
import { buildProductCallout } from '../callouts/productCalloutBuilder'
import { ProductCallout } from '../../components/AutoGenerate/types/AutomatedExperience'

const buildGoodBetterBestTiles = (
  goodBetterBestValues: GoodBetterBestValue[],
  pageDataFromBFF: BFFPageData,
  dictionaryEntries?: Record<string, string>,
  logger?: Logger
): (GoodBetterBestTile | undefined)[] => {
  const goodBetterBestTiles = goodBetterBestValues.map((gbbValue: GoodBetterBestValue) => {
    if (gbbValue.template) {
      return createGBBProductTileV2(gbbValue, pageDataFromBFF, dictionaryEntries, logger)
    }
    return undefined
  })

  return goodBetterBestTiles
}

const createGBBProductTileV2 = (
  gbbValue: GoodBetterBestValue,
  pageDataFromBFF: BFFPageData,
  dictionaryEntries?: Record<string, string>,
  logger?: Logger
) => {
  const tileProps = gbbValue.template
  if (tileProps) {
    const { allAvailableTags, calloutDetails, tileDetails, productsList } = tileProps
    const mpvId = productsList?.selectedProduct?.mpvId
    let gbbMpvTile: ProductTileModel = {}
    if (mpvId) {
      const gbbMpv = PageDataUtil.getMpv(mpvId, pageDataFromBFF)
      gbbMpvTile = ProductTileCollectionUtil.getTileV2FromMpv(mpvId, gbbMpv)
    }

    const gbbTileV2: GoodBetterBestTile = {
      name: tileDetails?.header?.value ?? '',
      description: tileDetails?.description?.value || '',
      formattedDescription: tileDetails?.formattedDescription?.value || '',
      imageUrl: tileDetails?.image?.cloudinaryImage?.[0]?.src,
      transformedPrimaryUrl: tileDetails?.link?.href,
      primaryUrlText: tileDetails?.urlText?.value ?? tileDetails?.link?.text ?? '',
      transformedSecondaryUrl: tileProps?.secondaryLink?.link?.href ?? '',
      secondaryUrlText:
        tileProps?.secondaryLink?.label?.value ?? tileProps?.secondaryLink?.link?.text ?? '',
      callout: buildProductCallout({
        callout: calloutDetails as CalloutDataType,
        isOutOfStock: gbbMpvTile?.isOutOfStock ?? false,
        allAvailableTags,
        outOfStockText: dictionaryEntries?.['outOfStock'] || '',
        logger,
        tileId: gbbValue.contentful_id
      }) as ProductCallout,
      showPrice: true,
      isOutOfStock: gbbMpvTile?.isOutOfStock ?? false,
      productId: gbbMpvTile?.productId,
      colorInformation: gbbMpvTile?.colorInformation,
      mpvId
    }

    return gbbTileV2
  }
  return undefined
}

const showGoodBetterBestSection = (goodBetterBestTiles: (GoodBetterBestTile | undefined)[]) => {
  return Boolean(
    goodBetterBestTiles &&
      !goodBetterBestTiles.includes(undefined) &&
      goodBetterBestTiles.length === 3
  )
}

export { buildGoodBetterBestTiles, showGoodBetterBestSection }
